export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export function clampPercent(value) {
  return Math.max(0, Math.min(100, Number(value) || 0));
}

function hexToRgb(hex) {
  const clean = hex.replace("#", "");
  return [
    parseInt(clean.slice(0, 2), 16),
    parseInt(clean.slice(2, 4), 16),
    parseInt(clean.slice(4, 6), 16),
  ];
}

function mixHex(from, to, amount) {
  const clamp = Math.max(0, Math.min(1, amount));
  const a = hexToRgb(from);
  const b = hexToRgb(to);
  const mixed = a.map((v, i) => Math.round(v + (b[i] - v) * clamp));
  return `rgb(${mixed[0]}, ${mixed[1]}, ${mixed[2]})`;
}

export function cityOccupancyColor(occupied, total) {
  const pct = total > 0 ? clampPercent((occupied / total) * 100) / 100 : 0;
  if (pct < 0.5) return mixHex("#2563eb", "#f59e0b", pct / 0.5);
  return mixHex("#f59e0b", "#16a34a", (pct - 0.5) / 0.5);
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(dateStr);
  if (Number.isNaN(target.getTime())) return null;
  target.setHours(0, 0, 0, 0);
  return Math.ceil((target - today) / 86400000);
}

export function normalizeDashboardData(value) {
  const data = value || {};
  const cities = asArray(data.cities);
  const monthly = asArray(data.monthly);
  const kpis = data.kpis || {};

  return {
    ...data,
    kpis,
    cities,
    monthly,
    type_distribution: asArray(data.type_distribution),
    top_locations: asArray(data.top_locations),
    expiring_soon: asArray(data.expiring_soon)
      .filter((item) => {
        const left = daysUntil(item.campaign_end);
        return left !== null && left >= 0 && left <= 7;
      })
      .sort((a, b) => new Date(a.campaign_end) - new Date(b.campaign_end)),
    recent_bookings: asArray(data.recent_bookings),
    most_profitable: asArray(data.most_profitable),
    loss_making: asArray(data.loss_making),
    city_counts: cities
      .map((city) => {
        const count = city.total || 0;
        const occupied = city.occupied || 0;
        const rawOccupancy = city.occupancy_pct ?? (count > 0 ? (occupied / count) * 100 : 0);
        const occupancyPct = Math.round(clampPercent(rawOccupancy));
        return {
          name: city.city,
          count,
          occupied,
          available: city.available || 0,
          maintenance: city.maintenance || 0,
          occupancyPct,
          color: cityOccupancyColor(occupied, count),
        };
      })
      .sort((a, b) => a.occupancyPct - b.occupancyPct || a.name.localeCompare(b.name)),
    trend: monthly.map((month) => ({ date: month.month, occ: month.occupied || 0 })),
    today: {
      enquiries: 0,
      bookings: kpis.occupied || 0,
      maintenance: kpis.maintenance || 0,
      revenue: kpis.monthly_revenue || 0,
    },
  };
}
